import type { MediaTextSectionModuleProps } from "./renderProps";
import { renderTextWithLineBreaks } from "./text";

export function MediaTextSectionModule({
  eyebrow,
  heading,
  body,
  layout = "IMAGE_RIGHT",
  image,
  ctaLabel,
  ctaUrl,
}: MediaTextSectionModuleProps) {
  return (
    <section
      className={`cms-section cms-media-text cms-media-text--${layout === "IMAGE_LEFT" ? "image-left" : "image-right"}`}
      data-cms-module="media-text-section"
    >
      <div className="cms-wrap cms-media-text__layout">
        <div className="cms-media-text__content">
          <div className="cms-eyebrow-row">
            <span className="cms-eyebrow">
              {renderTextWithLineBreaks(eyebrow || "Perspective")}
            </span>
          </div>
          {heading ? <h2>{renderTextWithLineBreaks(heading)}</h2> : null}
          {body ? (
            <p className="cms-media-text__body">
              {renderTextWithLineBreaks(body)}
            </p>
          ) : null}
          {ctaLabel && ctaUrl ? (
            <a
              className="cms-text-link"
              href={ctaUrl}
              rel="noopener noreferrer"
            >
              {ctaLabel}
            </a>
          ) : null}
        </div>
        {image ? (
          <figure className="cms-media-text__image">
            <img src={image.src} alt={image.alt} />
            {image.caption ? <figcaption>{image.caption}</figcaption> : null}
          </figure>
        ) : null}
      </div>
    </section>
  );
}
